import { UPLOAD_CA } from './constants';

export function uploadCA(args) {
  return {
    type: UPLOAD_CA,
    payload: args,
  };
}
